var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cmg-rewards-achievements"},[_c('cmg-rewards-achievements-header'),_c('cmg-rewards-achievements-body',{attrs:{"achievementYears":_vm.achievementYears}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }